// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__nudvi","col":"styles_col__3p16Q"};